<div class="flex flex-col gap-4">
    <app-table-loading-overlay></app-table-loading-overlay>
    <!-- Title 
    <div #title class="font-semibold tracking-wide uppercase text-surface-900" style="font-size: 16px;">
      {{ widgetHeader() }}
    </div>-->

        <!-- Error -->
        <div *ngIf="store.error()" class="text-sm text-red-600">
            {{ store.error() }}
        </div>

        <!-- Featured -->
        <ng-container *ngIf="store.top() as top">
            <div class="overflow-hidden rounded-xl border border-surface-200">
                <img class="h-48 w-full object-cover" [src]="top.imageLink" [alt]="top.header" />
            </div>

            <div class="space-y-2 ">
                <div class="font-bold text-surface-900 " style="font-size: 18px;">
                    {{ top.header }}
                </div>

                <div class="text-sm text-surface-700">
                    {{ top.shortDescription }}
                </div>

                <div class="flex items-center justify-between text-sm text-surface-500">
                    <span>{{ top.date || '' }}</span>

                    <a class="font-bold text-surface-900 hover:underline" [href]="top.link" target="_blank"
                        rel="noopener noreferrer">
                        Weiterlesen
                    </a>

                </div>
            </div>

            <p-divider class="my-0 gap-0"></p-divider>
        </ng-container>

        <!-- List -->
        <div class="divide-y divide-surface-200">
            <div *ngFor="let item of store.list()" class="py-3 flex items-start justify-between gap-4">
                <div class="min-w-0">
                    <div class="text-l font-bold text-surface-900">
                        {{ item.header }}
                    </div>
                    <div class="mt-1 text-sm text-surface-700 line-clamp-2">
                        {{ item.shortDescription }}
                    </div>
                </div>

                <div class="flex flex-col items-end gap-2 shrink-0">
                    <span class="text-[11px] text-surface-400">{{ item.date || '' }}</span>
                    <a class="text-[11px] font-bold text-surface-900 hover:underline" [href]="item.link" target="_blank"
                        rel="noopener noreferrer">
                        Weiterlesen
                    </a>

                </div>
            </div>
        </div>

</div>